import React, {Component} from 'react'
import CompanyChart from './CompanyChart'
import {compose, withState} from 'recompose'
import {message} from 'antd'
import Settings from '../../api/Settings'

class CompanyChartCont extends Component {
  componentDidMount() {
    this.fetch()
  }

  api = new Settings()
  fetch = async () => {
    try {
      this.props.fetch(true)
      const initechOrg = await this.api.get('companyChart')
      this.props.fetch(false)
      this.props.setChart(initechOrg)
    } catch (e) {
      this.props.fetch(false)
      message.error(e.errorMessage)
    }
  }

  render() {
    const {fetching, ...rest} = this.props
    return <CompanyChart {...rest} loading={fetching} />
  }
}

CompanyChartCont.propTypes = {}
CompanyChartCont.defaultProps = {}

export default compose(
  withState('fetching', 'fetch', false),
  withState('initechOrg', 'setChart', {}),
)(CompanyChartCont)
